import React, { useState, useRef, useEffect } from "react";

function EducationDropdown({value, onChange}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const dropdownRef = useRef(null);

  const data = [
    {
      category: { id: 1, name: "BACHELORS-ENGINEERING/COMPUTER/OTHERS" },
      options: [
        { id: 1, name: "Aeronautical Engineering" },
        { id: 2, name: "B.Arch" },
        { id: 3, name: "BCA" },
        { id: 4, name: "BE" },
        { id: 5, name: "B.Plan" },
        { id: 6, name: "B.Sc IT/Computer Science" },
        { id: 7, name: "B.Tech" },
        { id: 8, name: "Other Bachelor Degree in Engineering/Computers" },
        { id: 9, name: "B.S(Engineering)" }
      ],
    },
    {
      category: { id: 2, name: "MASTER-ENGINEERING/COMPUTER/OTHERS" },
      options: [
        { id: 10, name: "M.Arch" },
        { id: 11, name: "MCA" },
        { id: 12, name: "ME" },
        { id: 13, name: "M.Sc.IT/Computer Science" },
        { id: 14, name: "M.S.(Engg.)" },
        { id: 15, name: "M.Tech." },
        { id: 16, name: "PGDCA" },
        { id: 17, name: "Other Bachelor Degree in Engineering/Computers" }
      ],
    },
    {
      category: { id: 3, name: "BACHELORS-ARTS/SCIENCE/COMMERCE/OTHERS" },
      options: [
        { id: 18, name: "Aviation Degree" },
        { id: 19, name: "B.A" },
        { id: 20, name: "B.Com." },
        { id: 21, name: "B.Ed." },
        { id: 22, name: "BFA" },
        { id: 23, name: "BFT" },
        { id: 24, name: "BLIS" },
        { id: 25, name: "B.M.M." },
        { id: 26, name: "B.Sc." },
        { id: 27, name: "B.S.W" },
        { id: 28, name: "B.Phil." },
        { id: 29, name: "Other Bachelor Degree in Arts/Science/Commerce" }
      ],
    },
    {
      category: { id: 4, name: "MASTER-ARTS/SCIENCE/COMMERCE/OTHERS" },
      options: [
        { id: 30, name: "M.A." },
        { id: 31, name: "MCom" },
        { id: 32, name: "M.Ed." },
        { id: 33, name: "MFA" },
        { id: 34, name: "MLIS" },
        { id: 35, name: "M.Sc." },
        { id: 36, name: "MSW" },
        { id: 37, name: "M.Phil." },
        { id: 38, name: "Other Master Degree in Arts/Science/Commerce" }
      ],
    },
    {
      category: { id: 5, name: "BACHELORS-MANAGEMENT/OTHERS" },
      options: [
        { id: 39, name: "BBA" },
        { id: 40, name: "BFM(Financial Management)" },
        { id: 41, name: "BHM(Hotel Management)" },
         { id: 42, name: "Other Bachelor Degree in Management" },
        { id: 43, name: "BHA/BHM(Hospital Administration)" }
       
      ],
    },
    {
      category: { id: 6, name: "MASTER-MANAGEMENT/OTHERS" },
      options: [
        { id: 44, name: "MBA" },
        { id: 45, name: "MFM(Financial Management)" },
        { id: 46, name: "MHM(Hotel Management)" },
        { id: 47, name: "MHRM(Human Resource Management)" },
        { id: 48, name: "PGDM" },
         { id: 49, name: "Other Master Degree in Management" },
        { id: 50, name: "MHA/MHM(Hospital Administration)" },
       
      ],
    },
    {
      category: { id: 7, name: "BACHELORS-MEDICINE-GENERAL/DENTAL/SURGEON" },
      options: [
        { id: 51, name: "B.A.M.S." },
        { id: 52, name: "BDS" },
        { id: 53, name: "BHMS" },
        { id: 54, name: "BSMS" },
        { id: 55, name: "BUMS" },
        { id: 56, name: "BVSc" },
        { id: 57, name: "MBBS" }
      ],
    },
    {
      category: { id: 8, name: "MASTER-MEDICINE-GENERAL/DENTAL/SURGEON" },
      options: [
        { id: 58, name: "MDS" },
        { id: 59, name: "MD/MS(Medical)" },
        { id: 60, name: "MVSc" },
        { id: 61, name: "MCh" },
        { id: 62, name: "DNB" }
      ],
    },
    {
      category: { id: 9, name: "BACHELORS-MEDICINE/OTHERS" },
      options: [
        { id: 63, name: "BPharm" },
        { id: 64, name: "BPT" },
        { id: 65, name: "B.Sc. Nursing" },
        { id: 66, name: "Other Bachelor Degree in Medicine" }
      ],
    },
    {
      category: { id: 10, name: "MASTER-MEDICINE/OTHERS" },
      options: [
        { id: 67, name: "M.Pharm" },
        { id: 68, name: "MPT" },
        { id: 69, name: "Other Master Degree in Medicine" }
      ],
    },
    {
      category: { id: 11, name: "BACHELORS-LEGAL/OTHERS" },
      options: [
        { id: 70, name: "BGL" },
        { id: 71, name: "B.L." },
        { id: 72, name: "LL.B." },
        { id: 73, name: "Other Bachelor Degree in Legal" }
      ],
    },
    {
      category: { id: 12, name: "MASTER-LEGAL/OTHERS" },
      options: [
        { id: 74, name: "LL.M." },
        { id: 75, name: "M.L." },
        { id: 76, name: "Other Master Degree in Legal" }
      ],
    },
    {
      category: { id: 13, name: "FINANCE-ICWAI/CA/CS/CFA/OTHERS" },
      options: [
        { id: 77, name: "CA" },
        { id: 78, name: "CFA(Chartered Financial Analyst)" },
        { id: 79, name: "CS" },
        { id: 80, name: "ICWA" },
        { id: 81, name: "Other Degree/Qualification in Finance" }
      ],
    },
    {
      category: { id: 14, name: "SERVICE-IAS/IPS/IRS/IES/IFS/OTHERS" },
      options: [
        { id: 82, name: "IAS" },
        { id: 83, name: "IES" },
        { id: 84, name: "IFS" },
        { id: 85, name: "IRS" },
        { id: 86, name: "IPS" },
        { id: 87, name: "Other Degree in Service" }
      ],
    },
    {
      category: { id: 15, name: "DOCTORATES" },
      options: [
        { id: 88, name: "Ph.D." },
        { id: 89, name: "DM" },
        { id: 90, name: "Post Doctoral Fellow" },
        { id: 91, name: "Fellow of National Board(FNB)" }
      ],
    },
    {
      category: { id: 16, name: "DIPLOMA/OTHERS" },
      options: [
        { id: 92, name: "Diploma" },
        { id: 93, name: "Polytechnic" },
        { id: 94, name: "Trade School" },
        { id: 95, name: "Others" }
      ],
    },
    {
      category: { id: 17, name: "HIGHER SECONDARY/SECONDARY" },
      options: [
        { id: 96, name: "Higher Secondary School/ High School" }
      ],
    }
  ];

  const filteredData = data.map((section) => ({
    ...section,
    options: section.options.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    ),
  }));
useEffect(() => {
  if (value) {
    for (let section of data) {
      const match = section.options.find(opt => opt.id === value);
      if (match) {
        setSelected(match.name);        
        break;
      }
    }
  }
}, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelected(option.name);
    setIsOpen(false);
    setSearch("");
    onChange(option.id)
  };

   const disableRightClick = (e) => {
    e.preventDefault();
  };



  return (
    <div className="w-100" style={styles.container} ref={dropdownRef} onContextMenu={disableRightClick}>
      {/* Closed state */}
      <div className="form-control fs-6"  style={styles.dropdownHeader} onClick={() => setIsOpen(!isOpen)}>
        {selected || "Select Education"}
        <span style={styles.arrow}>{isOpen ? "▲" : "▼"}</span>
      </div>

      {/* Expanded state */}
      {isOpen && (
        <div style={styles.dropdownList}>
          <input
            
            type="text"
            placeholder=" Select your Education"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchBox}
            autoFocus
          />

          <div style={styles.scrollArea}>
            {filteredData.map((section) => (
              <div key={section.category.id}>
                <div style={styles.category}>-- {section.category.name} --</div>
                {section.options.length > 0 ? (
                  section.options.map((option) => (
                    <div
                      key={option.id}
                      style={styles.option}
                      onClick={() => handleSelect(option)}
                    >
                      {option.name}
                    </div>
                  ))
                ) : (
                  <div style={styles.noMatch}>No matches found</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    width: 400,
    marginTop:20,
    position: "relative",
    fontFamily: "Arial, sans-serif",
  },
  dropdownHeader: {
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize:"13px"
  },
  arrow: {
    fontSize: 12,
    color: "#555",
  },
  dropdownList: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: 4,
    marginTop: 2,
    zIndex: 100,
  },
  searchBox: {
    width: "100%",
    padding: "8px 10px",
    border: "none",
    borderBottom: "1px solid #eee",
    outline: "none",
  },
  scrollArea: {
    maxHeight: 180,
    overflowY: "auto",
  },
  category: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#888",
    padding: "6px 10px",
  },
  option: {
    padding: "6px 12px",
    cursor: "pointer",
  },
  noMatch: {
    padding: "6px 12px",
    color: "#999",
    fontStyle: "italic",
  },
};

export default EducationDropdown;
